import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardContent,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
  Button, 
} from '@material-ui/core';

// >> redux
import {
  setPlayerChecks
} from '../../../../../redux/actions/players';
// <<

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 600
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const PlayerTable = props => {
  const { className, players, onSetSelectedPlayers, ...rest } = props;

  const classes = useStyles();

  const [selectedPlayers, setSelectedPlayers] = useState([]);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [page, setPage] = useState(0);

  const handleSelectAll = event => {

    let selectedPlayers;

    if (event.target.checked) {
      selectedPlayers = players.map(player => player.id);
    } else {
      selectedPlayers = [];
    }

    setSelectedPlayers(selectedPlayers);
    onSetSelectedPlayers(selectedPlayers);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedPlayers.indexOf(id);
    let newSelectedPlayers = [];

    if (selectedIndex === -1) {
      newSelectedPlayers = newSelectedPlayers.concat(selectedPlayers, id);
    } else if (selectedIndex === 0) {
      newSelectedPlayers = newSelectedPlayers.concat(selectedPlayers.slice(1));
    } else if (selectedIndex === selectedPlayers.length - 1) {
      newSelectedPlayers = newSelectedPlayers.concat(selectedPlayers.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedPlayers = newSelectedPlayers.concat(
        selectedPlayers.slice(0, selectedIndex),
        selectedPlayers.slice(selectedIndex + 1)
      );
    }

    setSelectedPlayers(newSelectedPlayers);
    onSetSelectedPlayers(newSelectedPlayers);
  };

  useEffect(() => {
    //console.log('componentDidUpdate & players changed' + players);

    const newSelected = selectedPlayers.filter(id => {
      const findObj = players.find(obj => obj.id == id);
      return findObj !== undefined && findObj !== null;
    });

    setSelectedPlayers(newSelected);
    onSetSelectedPlayers(newSelected);

  }, [players]);

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={selectedPlayers.length > 0 && selectedPlayers.length === players.length}
                      color="primary"
                      indeterminate={
                        selectedPlayers.length > 0 &&
                        selectedPlayers.length < players.length
                      }
                      onChange={handleSelectAll}
                    />
                  </TableCell>
                  <TableCell>번호</TableCell>
                  <TableCell>플레이어명</TableCell>
                  <TableCell>버전코드</TableCell>
                  <TableCell>수정자</TableCell>
                  <TableCell>수정일</TableCell>
                  <TableCell>설명</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {players.map((player, index) => (
                  <TableRow
                    className={classes.tableRow}
                    hover
                    key={player.id}
                    selected={selectedPlayers.indexOf(player.id) !== -1}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedPlayers.indexOf(player.id) !== -1}
                        color="primary"
                        onChange={event => handleSelectOne(event, player.id)}
                        value="true"
                      />
                    </TableCell>
                    <TableCell>{index}</TableCell>
                    <TableCell>
                      <div className={classes.nameContainer}>
                        {/* <Avatar
                          className={classes.avatar}
                          src={category.avatarUrl}
                        >
                          {getInitials(category.name)}
                        </Avatar> */}
                        <Typography variant="body1">{player.name}</Typography>
                      </div>
                    </TableCell>
                    <TableCell>{player.version_code}</TableCell>
                    <TableCell>{player.modified_user}</TableCell>
                    <TableCell>
                      {moment(player.modified_at).format('YYYY-MM-DD')}
                    </TableCell>
                    <TableCell>{player.description ? player.description : ''}</TableCell>
                    {/* <TableCell>{category.email}</TableCell>
                    <TableCell>
                      {category.address.city}, {category.address.state},{' '}
                      {category.address.country}
                    </TableCell>
                    <TableCell>{category.phone}</TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      {/* <CardActions className={classes.actions}>
        <TablePagination
          component="div"
          count={categories.length}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </CardActions> */}
    </Card>
  );
};

PlayerTable.propTypes = {
  className: PropTypes.string,
  players: PropTypes.array.isRequired
};

// //export default CategoryTable;

// const mapStateToProps = state => ({
//   players: state.players.playersList
// });

// const mapDispatchToProps = dispatch => ({
//   // getCategories: () => {getCategories(dispatch)},
//   // addCategory: (category) => {addCategory(category, dispatch)},
//   setPlayerChecks: (checks) => {setPlayerChecks(checks, dispatch)},
// })

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps,
// )(PlayerTable);
export default PlayerTable;
